<template>
  <div style="overflow-y: auto;">
    <div class="wrapper">
      <ul class="sessions">
        <li v-for="(items, idx) in data" :key="'epglivetv-' + idx">
          <div
            class="w-100 d-flex flex-column"
            v-if="getCurrentEpgDesc(items.dateTimeStart, items.dateTimeEnd)"
          >
            <div class="time active">
              {{ timeConverter(items.dateTimeStart) }}
            </div>
            <p class="mb-1 active">{{ items.scheduleProgramTitle }}</p>
            <span class="desc">
              <!-- {{ truncateString(items.scheduleProgramDescription, 150) }} -->
              {{ items.scheduleProgramDescription }}
            </span>
          </div>
          <div v-else>
            <div class="time">{{ timeConverter(items.dateTimeStart) }}</div>
            <p>{{ items.scheduleProgramTitle }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'timeline-jadual-mobile',
  props: ['data'],
};
</script>

<style scoped>
@mixin tablet-and-up {
  @media screen and (min-width: 769px) {
    @content;
  }
}
@mixin mobile-and-up {
  @media screen and (min-width: 601px) {
    @content;
  }
}
@mixin tablet-and-down {
  @media screen and (max-width: 768px) {
    @content;
  }
}
@mixin mobile-only {
  @media screen and (max-width: 600px) {
    @content;
  }
}

ul,
li {
  list-style: none;
  padding: 0;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
  background: linear-gradient(45deg, #209cff, #68e0cf);
  padding: 3rem 0;
}
.wrapper {
  background: #171f26;
  padding: 16px;
  border-radius: 8px;
  height: 480px;
  overflow-y: auto;
}
h1 {
  font-size: 1.1rem;
  font-family: sans-serif;
}
.sessions {
  margin-top: 8px;
  border-radius: 12px;
  position: relative;
}
li {
  padding-bottom: 1.5rem;
  border-left: 2px solid #d9e021;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;
  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }
  &:before {
    content: '';
    width: 16px;
    height: 16px;
    background: #d9e021;
    border: 1px solid #d9e021;
    border-radius: 50%;
    position: absolute;
    left: -9px;
    top: 0px;
  }
}
.active {
  color: #d9e021 !important;
}
.time {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
}
p {
  color: #fff;
  text-align: left;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding-top: 8px;
}
.desc {
  color: #fff;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
}
</style>
